import { Prop, Component, Vue } from 'vue-property-decorator';
import localforage from 'localforage';

const UPDATE_NAME = 'XBOX_STREAMING_UPDATE';

@Component({})
export default class TopNav extends Vue {
  @Prop({ default: false })
  dismissible: boolean;

  isDismissed: boolean = false;

  async created() {
    if (this.dismissible)
      this.isDismissed = await localforage.getItem<boolean>(`${UPDATE_NAME}_DISMISSED`);
  }

  goToUpdate() {
    window.open('https://streamlabs.com/content-hub/post/streamlabs-console-update', '_blank');
  }

  async onClose() {
    this.isDismissed = true;
    await localforage.setItem(`${UPDATE_NAME}_DISMISSED`, true);
  }
}
